var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-stack h-stretch root"},_vm._l((_vm.items),function(item){return _c('div',{key:item.value,staticClass:"item",class:[item.value == _vm.value ? 'selected' : ''],on:{"click":function($event){return _vm.$emit('valuechanged', item.value)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }